import 'css-chunksrc/client/scenes/wbs/dateForm/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_1w352_1",
  "input": "_input_1w352_6",
  "placeholder": "_placeholder_1w352_22",
  "value": "_value_1w352_27",
  "calendarInput": "_calendarInput_1w352_32",
  "calendar": "_calendar_1w352_32",
  "timeList": "_timeList_1w352_48",
  "timeListWrapper": "_timeListWrapper_1w352_57",
  "time": "_time_1w352_48",
  "timeName": "_timeName_1w352_69",
  "invalid": "_invalid_1w352_75",
  "disabled": "_disabled_1w352_83"
};